import React, { useState, useEffect } from 'react';
import '../styles/BackToTop.css';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show the button when scrolled down 300px
  const toggleVisibility = () => {
    setIsVisible(window.scrollY > 300);
  };

  // Smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div className={`back-to-top ${isVisible ? 'show' : ''}`}>
      <button 
        onClick={scrollToTop} 
        className="scroll-to-top" 
        aria-label="Scroll to top" // Accessibility improvement
      >
        <span>Back to Top</span>
      </button>
    </div>
  );
};

export default BackToTop;
